// @flow

import { observer } from "mobx-react";
import React from "react";

import "./FacebookShareMedia.scss";

type Props = {
    url: string,
    onShare: Function
};

@observer
export default class FacebookShareMedia extends React.Component<Props> {
    handleClick() {
        window["FB"].ui({
            method: "share",
            href: this.props.url
        });

        this.props.onShare();
    }

    render() {
        return (
            <button
                type="button"
                className="FacebookShareMedia"
                onClick={this.handleClick.bind(this)}
                title="Share on Facebook"
            >
                <i className="fa fa-facebook" />
            </button>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/ShareMedia/FacebookShareMedia/FacebookShareMedia.js